import React from 'react';
import css from './index.module.css';

interface Props {
  currentStep: number;
  className?: string;
}

export default function Steps({ currentStep, className, ...rest }: Props) {
  return (
    <div className={`${css['steps']} ${className}`} {...rest}>
      <span
        className={
          css['steps-item'] + ' ' + (currentStep === 1 ? css['active'] : '')
        }
      />
      <span
        className={
          css['steps-item'] + ' ' + (currentStep === 2 ? css['active'] : '')
        }
      />
      <span
        className={
          css['steps-item'] + ' ' + (currentStep === 3 ? css['active'] : '')
        }
      />
    </div>
  );
}
